(() => {
  const intro = document.querySelector(".moxi-mobile-intro");
  const introToggle = document.querySelector(".moxi-mobile-intro-toggle");
  if (intro && introToggle) {
    introToggle.addEventListener("click", () => {
      const expanded = introToggle.getAttribute("aria-expanded") === "true";
      introToggle.setAttribute("aria-expanded", String(!expanded));
      intro.classList.toggle("is-expanded", !expanded);
    });
  }
  const sort = document.querySelector("[data-moxi-mobile-sort]");
  if (sort) {
    sort.addEventListener("change", () => {
      const url = new URL(window.location.href);
      url.searchParams.set("sort_by", sort.value);
      url.searchParams.delete("page");
      window.location.assign(url.toString());
    });
  }
  const closeConcierge = () => {
    if (window.matchMedia("(max-width: 767px)").matches && window.chatbase && typeof window.chatbase.close === "function") {
      window.chatbase.close();
    }
  };
  closeConcierge();
  window.addEventListener("load", closeConcierge, { once: true });
})();
